/**
 * @todo Удалить файл, если эксперимент будет неудачным
 * @description Данный функционал появился в задаче CD-138414, будет удалён в задаче CD-138473
 */

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getIsRentByOffer } from './deal_type';
import { getIsFreeAppointmentObjectByOffer, getIsOfficeByOffer, getIsTradeAreaByOffer } from './offer_type';

export function getIsContractTemplatesBlockEnabled(offer: IOfferSchema): boolean {
  return (
    getIsRentByOffer(offer) &&
    (getIsOfficeByOffer(offer) || getIsFreeAppointmentObjectByOffer(offer) || getIsTradeAreaByOffer(offer))
  );
}
